import { BetRadarSocketTypes, BetRadarEntityStatus } from "@nxplatform/platform-entities/sport/common-sport.entities";
import { Sections } from "../../entities/common-entities.js";
import { selectCompetitorNameById, selectCompetitorAgeGroupById } from "../../factor/betradar/factor-generator.js";
import { groupArrayToKeyData, groupByMultiplyProp } from "../group-by.js";
const replaceCompetitorsToTeams = (events, competitors) => events.map((event) => {
  var _a, _b, _c, _d;
  const team1Name = (_a = selectCompetitorNameById(
    competitors,
    event == null ? void 0 : event.competitor1Id
  )) == null ? void 0 : _a.name;
  const team2Name = (_b = selectCompetitorNameById(
    competitors,
    event == null ? void 0 : event.competitor2Id
  )) == null ? void 0 : _b.name;
  const team1AgeGroup = (_c = selectCompetitorAgeGroupById(
    competitors,
    event == null ? void 0 : event.competitor1Id
  )) == null ? void 0 : _c.ageGroup;
  const team2AgeGroup = (_d = selectCompetitorAgeGroupById(
    competitors,
    event == null ? void 0 : event.competitor2Id
  )) == null ? void 0 : _d.ageGroup;
  const team1 = team1AgeGroup ? `${team1AgeGroup} ${team1Name}` : team1Name;
  const team2 = team2AgeGroup ? `${team2AgeGroup} ${team2Name}` : team2Name;
  return { ...event, team1, team2 };
});
const sortLeaguesByDesc = (league) => league.sort((a, b) => Number(b.order) - Number(a.order));
var InitialExcluded = /* @__PURE__ */ ((InitialExcluded2) => {
  InitialExcluded2["leagues"] = "leagues";
  InitialExcluded2["odds"] = "odds";
  InitialExcluded2["entities"] = "entities";
  InitialExcluded2["players"] = "players";
  InitialExcluded2["results"] = "results";
  InitialExcluded2["categories"] = "categories";
  InitialExcluded2["totalPages"] = "totalPages";
  return InitialExcluded2;
})(InitialExcluded || {});
const updateBroadcastState = (type, payload, broadcasts) => {
  if (type === BetRadarSocketTypes.broadcastAdded || type === BetRadarSocketTypes.broadcastEnabled) {
    return [...broadcasts, payload];
  }
  if (type === BetRadarSocketTypes.broadcastDisabled || type === BetRadarSocketTypes.broadcastRemoved) {
    return broadcasts.filter(
      (broadcast) => broadcast.eventId !== payload.eventId
    );
  }
  if (type === BetRadarSocketTypes.broadcastUpdated) {
    return broadcasts.map((broadcast) => broadcast.eventId === payload.eventId ? payload : broadcast);
  }
  return broadcasts;
};
const updateInitialState = (state, payload, excludedFields = []) => {
  const updateState = state;
  const { relations, items = [] } = payload;
  const {
    tips = [],
    odds,
    statistics,
    players = [],
    broadcasts = [],
    result,
    attributes,
    additionalInfo,
    league = [],
    withMarketsCount,
    sportCategories = [],
    competitors = []
  } = relations || {};
  updateState.tips = Array.isArray(tips) ? tips : [];
  updateState.statistics = statistics;
  updateState.additionalInfo = additionalInfo || {};
  updateState.odds = odds;
  updateState.entities = replaceCompetitorsToTeams(
    items,
    competitors
  );
  if (!excludedFields.includes(
    "leagues"
    /* leagues */
  )) {
    updateState.leagues = sortLeaguesByDesc(league);
  }
  updateState.totalPages = payload.lastPage;
  updateState.results = result;
  updateState.players = players;
  updateState.competitors = competitors;
  updateState.attributes = attributes;
  updateState.categories = groupArrayToKeyData(
    sportCategories,
    "id"
  );
  updateState.broadcasts = broadcasts;
  updateState.marketsCount = withMarketsCount && Object.values(relations.withMarketsCount).reduce(
    (acc, cur) => ({
      ...acc,
      [cur.eventId]: cur
    }),
    {}
  );
};
const updateEventByType = (state, response, type) => {
  const { payload } = response;
  if (payload.odds) {
    state.odds[payload.eventId] = updateEventOdds(
      state.odds[payload.eventId],
      payload.odds
    );
  }
  if ([
    BetRadarSocketTypes.broadcastAdded,
    BetRadarSocketTypes.broadcastEnabled,
    BetRadarSocketTypes.broadcastDisabled,
    BetRadarSocketTypes.broadcastRemoved,
    BetRadarSocketTypes.broadcastUpdated
  ].includes(response.type)) {
    state.broadcasts = updateBroadcastState(
      response.type,
      payload,
      state.broadcasts
    );
  }
  if ([
    BetRadarSocketTypes.close,
    BetRadarSocketTypes.ended,
    BetRadarSocketTypes.eventStopped,
    BetRadarSocketTypes.startLive,
    BetRadarSocketTypes.eventChanged
  ].includes(response.type) && typeof state.reload !== "undefined") {
    state.reload = true;
  }
  if (type === Sections.live) {
    if (response.type === BetRadarSocketTypes.eventSportStatusChanged) {
      state.results[payload.eventId] = payload.status;
      state.attributes[payload.eventId] = payload.attributes;
    }
  }
  if (response.type === BetRadarSocketTypes.betStop) {
    Object.values(state.odds[payload.eventId] || {}).forEach(
      (market) => market.status = BetRadarEntityStatus.suspended
    );
  }
};
const updateEventOdds = (storedOdds, newOdds) => {
  const storedData = JSON.parse(JSON.stringify(storedOdds || []));
  const stored = groupByMultiplyProp(storedData, ["id", "specifiers"]);
  const newOddsData = groupByMultiplyProp(Object.values(newOdds || {}), [
    "id",
    "specifiers"
  ]);
  const newOddsDataWithMergedOutcomes = Object.keys(newOddsData).reduce((acc, key) => {
    var _a, _b;
    const odd = { ...newOddsData[key] };
    if (!((_a = odd.outcomes) == null ? void 0 : _a.length)) {
      odd.outcomes = ((_b = stored[key]) == null ? void 0 : _b.outcomes) || [];
    }
    acc[key] = odd;
    return acc;
  }, {});
  return Object.values({ ...stored, ...newOddsDataWithMergedOutcomes });
};
const clearEventsState = (state, initial) => {
  state.results = initial.results;
  state.entities = initial.entities;
  state.leagues = initial.leagues;
  state.competitors = initial.competitors;
  state.factors = initial.factors;
  state.results = initial.results;
  state.odds = initial.odds;
  state.broadcasts = initial.broadcasts;
  state.loaded = false;
  state.initial = false;
};
export {
  InitialExcluded,
  clearEventsState,
  replaceCompetitorsToTeams,
  sortLeaguesByDesc,
  updateBroadcastState,
  updateEventByType,
  updateEventOdds,
  updateInitialState
};
